import { render, staticRenderFns } from "./PopupFoodDiaryReminder.vue?vue&type=template&id=7ac880e8&scoped=true"
import script from "./PopupFoodDiaryReminder.vue?vue&type=script&lang=js"
export * from "./PopupFoodDiaryReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac880e8",
  null
  
)

export default component.exports